import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const SearchBar = ({ onSearch, onVoiceSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [recentSearches, setRecentSearches] = useState([
    'медитация',
    'философия',
    'путешествия',
    'музыка'
  ]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef?.current && !searchRef?.current?.contains(event?.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    setShowSuggestions(value?.length > 0);
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      onSearch(searchQuery);
      setShowSuggestions(false);
      if (!recentSearches?.includes(searchQuery)) {
        setRecentSearches(prev => [searchQuery, ...prev?.slice(0, 4)]);
      }
    }
  };

  const handleVoiceSearch = () => {
    setIsListening(true);
    setTimeout(() => {
      setIsListening(false);
      const mockVoiceQuery = 'философия жизни';
      setSearchQuery(mockVoiceQuery);
      onVoiceSearch(mockVoiceQuery);
    }, 2000);
  };

  const handleRecentSearchClick = (query) => {
    setSearchQuery(query);
    onSearch(query);
    setShowSuggestions(false);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setShowSuggestions(false);
  };

  return (
    <div className="search-bar-container relative" ref={searchRef}>
      <form onSubmit={handleSearchSubmit} className="search-form">
        <div className="search-input-wrapper relative">
          <div className="search-icon absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
            <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
          </div>
          
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            onFocus={() => setShowSuggestions(true)}
            placeholder="Поиск эфиров, голосов, тем..."
            className="search-input w-full h-14 pl-12 pr-24 rounded-lg bg-card border border-border text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all duration-200"
            aria-label="Поиск контента"
          />

          {searchQuery && (
            <button
              type="button"
              onClick={clearSearch}
              className="clear-button absolute right-16 top-1/2 -translate-y-1/2 p-2 rounded-full hover:bg-muted transition-colors duration-200"
              aria-label="Очистить поиск"
            >
              <Icon name="X" size={16} color="var(--color-muted-foreground)" />
            </button>
          )}

          <button
            type="button"
            onClick={handleVoiceSearch}
            disabled={isListening}
            className={`voice-button absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full transition-all duration-200 ${
              isListening 
                ? 'bg-error text-error-foreground animate-pulse' 
                : 'hover:bg-muted text-muted-foreground'
            }`}
            aria-label="Голосовой поиск"
          >
            <Icon 
              name={isListening ? "Mic" : "Mic"} 
              size={20} 
              color={isListening ? "var(--color-error-foreground)" : "currentColor"} 
            />
          </button>
        </div>
      </form>
      {showSuggestions && (
        <div className="search-suggestions absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-soft-lg overflow-hidden z-50 animate-fade-in">
          {searchQuery?.length === 0 && recentSearches?.length > 0 && (
            <div className="recent-searches p-4">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-heading font-semibold text-foreground">
                  Недавние поиски
                </h3>
                <button
                  onClick={() => setRecentSearches([])}
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors duration-200"
                >
                  Очистить
                </button>
              </div>
              <ul className="space-y-2">
                {recentSearches?.map((query, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleRecentSearchClick(query)}
                      className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200 text-left"
                    >
                      <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
                      <span className="text-sm text-foreground">{query}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {searchQuery?.length > 0 && (
            <div className="search-results p-4">
              <h3 className="text-sm font-heading font-semibold text-foreground mb-3">
                Популярные запросы
              </h3>
              <ul className="space-y-2">
                {['медитация и осознанность', 'философские беседы', 'путешествия по миру']?.map((suggestion, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleRecentSearchClick(suggestion)}
                      className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200 text-left"
                    >
                      <Icon name="TrendingUp" size={16} color="var(--color-primary)" />
                      <span className="text-sm text-foreground">{suggestion}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;